export enum DateFormats {
	DayMonthYear, // DD/MM/YYYY
	YearMonthDay, // YYYY-MM-DD
	WordsWithWeekDay, // e.g. Mon Jan 22 2020
	DayMonthYearTime, // DD/MM/YYY - HH:MM
}

const DAYS_OF_WEEK = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Show html date input if the screen is small
 * and the browser accepts input with type date
 * @param format
 */
export const shouldShowInbuilt = (format?: DateFormats) => {
	// Html date input cannot accept words
	if (format === DateFormats.WordsWithWeekDay)
		return false;

	// if the width is less than arbitrary tablet-y width, show the inbuilt date picker...
	const tabletWidth = 800;
	const portrait = window.innerWidth < window.innerHeight;
	const smallEnough = portrait ? window.innerWidth < tabletWidth : window.innerHeight < tabletWidth;
	return smallEnough && datePickerSupported();
};

export const datePickerSupported = (): boolean => {
	// builds a quick date input, checks to see if it is implemented correctly.
	// Safari for example doesn't implement date type inputs.
	const input = document.createElement('input');
	const value = 'a';
	input.setAttribute('type', 'date');
	input.setAttribute('value', value);
	return (input.value !== value);
};

export const getFullDateLocalTimeZone = (date: Date, format?: DateFormats): string => {
	function pad(n: number) {
		return n < 10 ? '0' + n : n;
	}

	switch (format) {
		case DateFormats.YearMonthDay:
			return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
		case DateFormats.WordsWithWeekDay:
			return `${DAYS_OF_WEEK[date.getDay()]} ${MONTHS[date.getMonth()]} ${pad(date.getDate())} ${date.getFullYear()}`;
		case DateFormats.DayMonthYearTime:
			return pad(date.getDate()) + '/' + pad(date.getMonth() + 1) + '/' + date.getFullYear()
				+ ' - ' + pad(date.getHours()) + ':' + pad(date.getMinutes());
		case DateFormats.DayMonthYear:
		default:
			return pad(date.getDate()) + '/' + pad(date.getMonth() + 1) + '/' + date.getFullYear();
	}
};

// Get the full date according to the UTC timezone, rather than the local one (which is the default for Date objects)
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
export const getFullDateUtc = (date: Date, format?: DateFormats): string => {
	function pad(n: number) {
		return n < 10 ? '0' + n : n;
	}

	switch (format) {
		case DateFormats.YearMonthDay:
			return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate());
		case DateFormats.WordsWithWeekDay:
			return `${DAYS_OF_WEEK[date.getUTCDay()]} ${MONTHS[date.getUTCMonth()]} ${pad(date.getUTCDate())} ${date.getUTCFullYear()}`;
		case DateFormats.DayMonthYearTime:
			return pad(date.getUTCDate()) + '/' + pad(date.getUTCMonth() + 1) + '/' + date.getUTCFullYear()
				+ ' - ' + pad(date.getUTCHours()) + ':' + pad(date.getUTCMinutes());
		case DateFormats.DayMonthYear:
		default:
			return pad(date.getUTCDate()) + '/' + pad(date.getUTCMonth() + 1) + '/' + date.getUTCFullYear();
	}
};
